import MUICheckbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

const Checkbox = ({ error, label, helperText, ...checkboxProps }) => {
  const [focused, setFocused] = useState(false)

  const checkboxComponent = (
    <MUICheckbox
      className={focused ? 'focused' : ''}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      {...checkboxProps}
    />
  )

  return (
    <FormControl error={error}>
      <FormControlLabel control={checkboxComponent} label={label} />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}

Checkbox.propTypes = {
  error: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.node,
}

Checkbox.defaultProps = {
  error: false,
  helperText: null,
  label: null,
}

export default Checkbox
